// extracted by mini-css-extract-plugin
export default {"modal":"Vda-z","modalContent":"Wda-z","footer":"Xda-z","cancelBtn":"Yda-z","disabled":"Zda-z","formWrapper":"_da-z","fade":"aea-z","fade-in":"bea-z","iframe":"cea-z"};